module.exports = __webpack_public_path__ + "static/media/deal_process.2eb0904d.png";